import qs from "qs";

export class LeadManagement {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/lead_management`;
  }

  async importLead(params) {
    const url = `${this.baseURL}/import_lead`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async bookingLeadAgent(id) {
    const url = `${this.baseURL}/new_contact/${id}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async list(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });

    const url = `${this.baseURL}/list${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async homeList(id, params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });

    const url = `${this.baseURL}/list/${id}${queryString}`;
    const config =
      params && params.format === "xlsx" ? { responseType: "blob" } : undefined;

    const response = await this.httpClient.request("get", url, config);

    return response;
  }

  async searchAllHomeList(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });

    const url = `${this.baseURL}/search_all_lead${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async detailContact(id) {
    const url = `${this.baseURL}/detail/${id}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async update(params) {
    const url = `${this.baseURL}/update`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async getAdminPermissionAgent() {
    const url = `${this.baseURL}/permissionAgent`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async generateLead(params) {
    const url = `${this.baseURL}/generate`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async deleteLead(leadId) {
    const url = `${this.baseURL}/delete`;

    const response = await this.httpClient.request("put", url, {
      data: { lead_id: leadId }
    });

    return response;
  }

  async getHomeContactHistoryList(homeId) {
    const url = `${this.baseURL}/home_contact_history/${homeId}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getTargetingList(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true,
      indices: false
    });

    const url = `${this.baseURL}/targetings${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getTargetingDetail(targetingId) {
    const url = `${this.baseURL}/targetings/${targetingId}`;
    const response = await this.httpClient.request("get", url);
  
    return response; 
  }

  async createTargeting(params) {
    const url = `${this.baseURL}/targetings/create_action`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }
}
